import React, {useState, useEffect} from "react";
import {Modal, Form, Input, InputNumber, Switch, Button, Divider} from "antd";

const labelStyle = {marginBottom: 0, fontWeight: 500};

const PoolSupporterEditModal = ({visible, onCancel, onSave, initialValues = {}}) => {
    const [form] = Form.useForm();
    const [isReturningCourierAssignActive, setIsReturningCourierAssignActive] = useState(initialValues.returningCourierAssignActive || false);
    const [isSupporterCourierAssignActive, setIsSupporterCourierAssignActive] = useState(initialValues.supporterCourierAssignActive || false);

    useEffect(() => {
        if (visible) {
            form.setFieldsValue(initialValues);
            setIsReturningCourierAssignActive(initialValues.returningCourierAssignActive || false);
            setIsSupporterCourierAssignActive(initialValues.supporterCourierAssignActive || false);
        }
    }, [visible, initialValues, form]);

    function handleOk() {
        form.validateFields().then(values => {
            onSave(values);
        });
    }

    return (
        <Modal
            title="Havuz Ayarlarını Düzenle"
            visible={visible}
            onCancel={onCancel}
            onOk={handleOk}
            footer={null}
            width={500}
            destroyOnClose
        >
            <Form form={form} layout="vertical" initialValues={initialValues} onFinish={onSave}>
                <Form.Item
                    label="Havuz Adı"
                    name="name"
                    rules={[{required: true, message: "Havuz adı zorunlu"}]}
                >
                    <Input placeholder="Havuz adı" disabled />
                </Form.Item>
                <Form.Item name="returningCourierAssignActive" valuePropName="checked" style={{marginBottom: 8}}>
                    <div style={{display: "flex", alignItems: "center"}}>
                        <Switch size="small" checked={isReturningCourierAssignActive} onChange={setIsReturningCourierAssignActive} />
                        <span style={{whiteSpace: "nowrap", color: '#888', fontSize: 13, marginLeft: 8}}>
                            Geri Dönen Kuryeye Ata
                        </span>
                    </div>
                </Form.Item>
                <Form.Item
                    label={<span style={labelStyle}>Geri Dönen Kurye Atama Mesafesi (m)</span>}
                    required={isReturningCourierAssignActive}
                >
                    <Form.Item
                        name="returningCourierDistance"
                        noStyle
                        rules={[{required: isReturningCourierAssignActive, message: "Zorunlu alan"}]}
                    >
                        <InputNumber
                            min={0}
                            style={{width: "100%"}}
                            placeholder="Örn: 500"
                            disabled={!isReturningCourierAssignActive}
                        />
                    </Form.Item>
                </Form.Item>
                <Divider />
                <Form.Item name="supporterCourierAssignActive" valuePropName="checked" style={{marginBottom: 8}}>
                    <div style={{display: "flex", alignItems: "center"}}>
                        <Switch size="small" checked={isSupporterCourierAssignActive} onChange={setIsSupporterCourierAssignActive} />
                        <span style={{whiteSpace: "nowrap", color: '#888', fontSize: 13, marginLeft: 8}}>
                            Destekçi Kurye Çek
                        </span>
                    </div>
                </Form.Item>
                <Form.Item
                    label={
                        <span style={labelStyle}>Destek İçin Beklenecek Sipariş Süresi (dk)</span>
                    }
                    required={isSupporterCourierAssignActive}
                >
                    <Form.Item
                        name="supportWaitTime"
                        noStyle
                        rules={[{required: isSupporterCourierAssignActive, message: "Zorunlu alan"}]}
                    >
                        <InputNumber
                            min={0}
                            style={{width: "100%"}}
                            placeholder="Örn: 10"
                            disabled={!isSupporterCourierAssignActive}
                        />
                    </Form.Item>
                </Form.Item>
                <Form.Item
                    label="Destekçi Atama Mesafesi (m)"
                    name="supportDistance"
                    rules={[{required: isSupporterCourierAssignActive, message: "Zorunlu alan"}]}
                >
                    <InputNumber
                        min={0}
                        style={{width: "100%"}}
                        placeholder="Örn: 2000"
                        disabled={!isSupporterCourierAssignActive}
                    />
                </Form.Item>
                <Form.Item style={{textAlign: "right", marginBottom: 0}}>
                    <Button type="primary" htmlType="submit">
                        Kaydet
                    </Button>
                </Form.Item>
            </Form>
        </Modal>
    );
};

export default PoolSupporterEditModal;
